<!--
 * @version: V1.0.0
 * @Date: 2023-09-21 10:18:36
 * @LastEditors: lzq
 * @LastEditTime: 2023-10-09 16:46:44
 * @company: 睿展数据
 * @FilePath: \udi-web\src\pages\system\version\index.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-card>
    <div class="container">
      <div class="header">
        <div class="header-item text-center" style="width: 120px">版本号</div>
        <div class="header-item" style="flex: 1">版本内容</div>
        <div class="header-item text-center" style="width: 120px">上线时间</div>
      </div>
      <div class="main" v-for="version in versionInfo" :key="version.id">
        <div class="main-item text-center" style="width: 120px">{{ version.versionsNo }}</div>
        <div class="main-item" style="flex: 1">
          <div v-if="version.contentInfo.update">
            [ 更新 ]<br />
            {{ version.contentInfo.update }}
          </div>
          <div v-if="version.contentInfo.optimization">
            [ 优化 ]<br />
            {{ version.contentInfo.optimization }}
          </div>
          <div v-if="version.contentInfo.repair">
            [ 修复 ]<br />
            {{ version.contentInfo.repair }}
          </div>
        </div>
        <div class="main-item text-center" style="width: 120px">
          {{ version.newTime ? parseTime(version.newTime, '{y}-{m}-{d}') : null }}
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { Loading } from 'element-ui'
import { getVersionInfo } from '@/api/system/config.js'

export default {
  // import引入的组件需要注入到对象中才能使用
  name: 'Version',
  data() {
    // 这里存放数据
    return {
      versionInfo: [],
      loading: false
    }
  },
  // filters: {
  //   formate(value) {
  //     return value.replace(/\n/g, '<br>')
  //   }
  // },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getVersionInfo() {
      const loadingInstance = Loading.service({})
      getVersionInfo({'appValue':'wms'})
        .then((res) => {
          this.versionInfo = res.rows
            .map((item) => {
              return {
                ...item,
                contentInfo: JSON.parse(item.contentInfo)
              }
            })
            .sort((a, b) => {
              return new Date(b.newTime).getTime() - new Date(a.newTime).getTime()
            })
        })
        .finally(() => {
          loadingInstance.close()
        })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getVersionInfo()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
}
</script>
<style lang="scss" scoped>
.header,
.main {
  width: 100%;
  display: flex;
  font-size: 14px;
  .text-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .main-item {
    white-space: pre-line;
    background: #ffffff;
    border: 1px solid #ebeef5;
    padding: 12px 10px;
  }
  .header-item {
    font-weight: bolder;
    border: 1px solid #e1e3e9;
    background: #ebeef5;
    padding: 12px 10px;
  }
}
</style>
